import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-menumaster',
  templateUrl: './menumaster.component.html',
  styleUrls: ['./menumaster.component.scss']
})
export class MenumasterComponent implements OnInit {
public user:any=[]
  constructor(public appservice:AppService,public toastr:ToastrService) { }
onSubmitUser() {
  this.appservice.postTable("api/Transaction/insert_UserMaster",this.user).subscribe({
    next:(res:any)=>{
     if(res){
      this.toastr.success("Details Saved Successfully","Notification")
     }
    },
    error:(err:any)=>{
     this.toastr.error(err,"Error");
    }})
  console.log(this.user);
}
  ngOnInit(): void {
  }

}
